import InfoPage from "./InfoPage";

export default function Contact() {
  return (
    <InfoPage
      title="Contact Us"
      description="Get in touch with the Trescend team for questions, content reports, or payout issues."
    >
      <p>
        Have a question, a report about content on Trescend, or a payout
        issue? Reach us at{" "}
        <a href="mailto:contact@trescend.app" style={{ color: "#f5c542" }}>
          contact@trescend.app
        </a>.
      </p>
      <p>
        We acknowledge every message within 24 hours and aim to resolve
        complaints within 15 days.
      </p>
      <p>
        If you're reporting content that violates our{" "}
        <a href="/terms" style={{ color: "#f5c542" }}>Terms of Use</a>, you can
        also use the Help &amp; Feedback option inside the app for a faster
        response.
      </p>
    </InfoPage>
  );
}

